// Módulos que DingDong habilita por comunidad (columna `features` en la API).
// Espejo de Community::hasFeature(): activo y, si tiene `trial_until`, sin vencer
// (cuenta el día completo).
export type Feature = 'argos' | 'vinte';

export function hasFeature(community: any, feature: Feature): boolean {
  const config = community?.features?.[feature];
  if (!config?.enabled) return false;
  if (!config.trial_until) return true;

  const today = new Date().toISOString().slice(0, 10);
  return today <= config.trial_until;
}
